import moment from 'moment';

export const getDateTimeObjectFromMoment = (t) => {
  if (!t || !t.isValid()) return null;
  return {
    year: t.year(),
    month: t.month() + 1,
    day: t.date(),
    hour: t.hour(),
    minute: t.minute(),
    second: t.second(),
    timestamp: t.valueOf(),
  };
};

export const getDateObjectFromMoment = (t) => {
  if (!t || !t.isValid()) return null;
  return {
    year: t.year(),
    month: t.month() + 1,
    day: t.date(),
  };
};

export const getMomentFromDateObject = (t) => {
  if (!t) return null;
  const { year, month, day } = t;
  const parsed = moment({
    year: year,
    month: month - 1,
    date: day,
  });

  return parsed.isValid() ? parsed : null;
};

export const getEndOfDayMomentFromDateObject = (t) => {
  if (!t) return null;
  const { year, month, day } = t;
  const parsed = moment({
    year: year,
    month: month - 1,
    date: day,
  }).endOf('day');

  return parsed.isValid() ? parsed : null;
};

export const getHourStringFromMoment = (t) => {
  return t.format('HH:mm');
};

export const getTodayTimeFilter = () => {
  const now = moment();
  const startOfDay = now.clone().startOf('day');
  const endOfDay = now.clone().endOf('day');
  return { from: startOfDay, to: endOfDay };
};

export const getLastDayTimeFilter = () => {
  const now = moment();
  const startOfDay = now.clone().subtract(24, 'hours');
  const endOfDay = now.clone();
  return { from: startOfDay, to: endOfDay };
};

export const getYesterdayTimeFilter = () => {
  const now = moment();
  const startOfDay = now.clone().subtract(1, 'days').startOf('day');
  const endOfDay = now.clone().subtract(1, 'days').endOf('day');
  return { from: startOfDay, to: endOfDay };
};

export const getLastWeekTimeFilter = () => {
  const now = moment();
  const startOfWeek = now.clone().subtract(1, 'weeks').startOf('day');
  const endOfWeek = now.clone().endOf('day');
  return { from: startOfWeek, to: endOfWeek };
};

export const getLastMonthTimeFilter = () => {
  const now = moment();
  const startOfMonth = now.clone().subtract(1, 'months').startOf('day');
  const endOfMonth = now.clone().endOf('day');
  return { from: startOfMonth, to: endOfMonth };
};

export const getTimeFilters = () => {
  return [
    {
      name: 'today',
      displayName: 'FILTERS.DATE.TODAY',
      value: getTodayTimeFilter(),
    },
    {
      name: 'lastDay',
      displayName: 'FILTERS.DATE.LAST DAY',
      value: getLastDayTimeFilter(),
    },
    {
      name: 'yesterday',
      displayName: 'FILTERS.DATE.YESTERDAY',
      value: getYesterdayTimeFilter(),
    },
    {
      name: 'lastWeek',
      displayName: 'FILTERS.DATE.LAST WEEK',
      value: getLastWeekTimeFilter(),
    },
    {
      name: 'lastMonth',
      displayName: 'FILTERS.DATE.LAST MONTH',
      value: getLastMonthTimeFilter(),
    },
  ];
};

export const getPeriodFromTimeFilter = (timeFilter) => {
  const timeFilters = getTimeFilters();

  const parsedTimeFilters = timeFilters.map((filter) => ({
    ...filter,
    value: {
      from: getDateTimeObjectFromMoment(filter.value.from),
      to: getDateTimeObjectFromMoment(filter.value.to),
    },
  }));

  // If any of the timeFilters values match the provided timeFilter object,
  // return the corresponding name.
  const matchedFilter = parsedTimeFilters.find(
    (filter) =>
      filter.value.from.timestamp === timeFilter.from.timestamp &&
      filter.value.to.timestamp === timeFilter.to.timestamp
  );

  return matchedFilter ? matchedFilter.name : null;
};
